export enum AspectsTableViewEnum {
    TonalityIndex = 'tonality-index',
    StrongWeak = 'strong-weak',
}

export enum AspectStrengthEnum {
    Strong = 'strong',
    Weak = 'weak',
    Neutral = 'neutral',
}
